<template>

<v-flex xs12 sm12 md12>
    <span style="padding-left: 18px;" class="title">REZERVASYON BİLGİLERİ</span>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="d-flex align-content-start flex-wrap" color="grey lighten-2" flat tile>
            <v-card v-if="paket !== null" class="pa-2 font-weight-bold" outlined tile>{{ paket.TurAdi }}</v-card>

          </v-card>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="d-flex align-content-start flex-wrap" color="grey lighten-2" flat tile>
            <v-card v-if="paket !== null" class="pa-2" outlined tile> {{ paket.Gece }} Gece - {{ paket.Gunduz }}
              Gündüz</v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="d-flex align-content-start flex-wrap" color="grey lighten-2" flat tile>
            <v-card class="pa-2" outlined tile>{{ altGrup.SatisFiyat.OtelKategori }} Otel</v-card>

          </v-card>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="d-flex align-content-start flex-wrap" color="grey lighten-2" flat tile>
            <v-card class="pa-2" outlined tile>Tur No: {{ paket.TurKodu }}</v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="d-flex align-content-start flex-wrap" color="primary" flat tile>
            <v-card class="pa-2 white--text" color="primary" outlined tile>Konaklama</v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="d-flex align-content-start flex-wrap" color="grey lighten-2" flat tile>
            <v-card class="pa-2" outlined tile>

              <span> Otel</span><br>
              <span> {{ altGrup.SatisFiyat.Otel.isim }} </span>

            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="d-flex align-content-start flex-wrap" color="primary" flat tile>
            <v-card class="pa-2 white--text" color="primary" outlined tile>Tur Paketi</v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="this.altGrup !== null" class="text-center">
        <v-col cols="12">
          <v-card class="d-flex align-content-start flex-wrap" color="grey lighten-2" flat tile>
            <v-card class="pa-2" outlined tile>

              <span> Yetişkin : </span><br>
              <span> Çocuk : </span><br>
              <span> Bebek : </span><br>
              <span> Ek Hizmet : </span><br>
              <span> Toplam :</span>
            </v-card>
            <v-card class="pa-2" outlined tile>

              <span> {{ this.fiyatlar.Yetiskin.sayi }} </span><br>
              <span> {{ this.fiyatlar.Cocuk.sayi }} </span><br>
              <span> {{ this.fiyatlar.Bebek.sayi }} </span><br>
              <span> {{ this.fiyatlar.EkHizmetler.sayi }} </span><br>

            </v-card>
            <v-card class="pa-2" outlined tile>
              <span> {{ this.fiyatlar.Yetiskin.fiyat }} {{ altGrup.SatisFiyat.ParaBirimi }}</span><br>
              <span> {{ this.fiyatlar.Cocuk.fiyat }} {{ altGrup.SatisFiyat.ParaBirimi }} </span><br>
              <span> {{ this.fiyatlar.Bebek.fiyat }} {{ altGrup.SatisFiyat.ParaBirimi }}</span><br>
              <span class="text-h4"> {{ this.fiyatlar.EkHizmetler.fiyat }} {{ altGrup.SatisFiyat.ParaBirimi }}</span><br>
              <span class="text-h4"> {{ this.fiyatlar.EkHizmetler.fiyat +
              this.fiyatlar.Yetiskin.fiyat + this.fiyatlar.Cocuk.fiyat + this.fiyatlar.Bebek.fiyat}} {{ altGrup.SatisFiyat.ParaBirimi }}</span><br>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-flex>
</template>

<script>
import PersonForm from './PersonForm.vue';
import tool from '../../coper/tools';

export default {
    components: {
        PersonForm,
    },
    data() {
        return {
        };
    },
    props: {
        fiyatlar: {
            type: Object,
            required: true,
        },
        paket: {
            type: Object,
            required: true,
        },
        altGrup: {
            type: Object,
            required: true,
        },
    },
    methods: {
    },
    mounted() {
    },
};
</script>